// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RoadmapFiltersController from "./roadmap_filters_controller"
application.register("roadmap-filters", RoadmapFiltersController)

import RoadmapInlineEditController from "./roadmap_inline_edit_controller"
application.register("roadmap-inline-edit", RoadmapInlineEditController)

import RoadmapModalController from "./roadmap_modal_controller"
application.register("roadmap-modal", RoadmapModalController)

import RoadmapSortableController from "./roadmap_sortable_controller"
application.register("roadmap-sortable", RoadmapSortableController)

import RoadmapTabsController from "./roadmap_tabs_controller"
application.register("roadmap-tabs", RoadmapTabsController)

import RoadmapPrintController from "./roadmap_print_controller"
application.register("roadmap-print", RoadmapPrintController)

import RoadmapChecklistController from "./roadmap_checklist_controller"
application.register("roadmap-checklist", RoadmapChecklistController)

import LandingSortableController from "./landing_sortable_controller"
application.register("landing-sortable", LandingSortableController)
